module.exports = {
    "register": "注册",
    "mobile": "手机号码",
    "or": "也可以用",
    "registerWithEmail": "邮箱注册",
    "password": "密码",
    "invitationCode": "邀请码",
    "getMobileCode": "获取验证码",
    "mobileCode": "验证码",
    "notMobileCode": "获取不到验证码?",
    "submit": "提交",
    "haveAccount": "已经有账号?",
    "login": "登录",
    "userExists": "该账号已存在",
    "emailInvalid": "请输入正确的邮箱地址",
    "mobileInvalid": "请输入正确的手机号码",
    "passwordLength": "密码必须包含 6 到 20 个字符",
    "captchaEmpty": "请点击按钮完成验证",
    "required": "必填",
    "mobileCodeInvalid": "请输入手机短信获取的验证码",
    "registerWithMobile": "手机注册",
    "email": "邮箱地址",
    "retryMobileCode": "后重新获取",
    "mobileOrEmail": "手机号/用户名/邮箱",
    "forgetPassword": "忘记密码?",
    "accountInvalid": "请输入正确的手机号或邮箱地址",
    "account": "账号",
    "username": "用户名",
    "registerTime": "注册时间",
    "lastLoginTime": "上次登录",
    "edit": "编辑",
    "save": "保存",
    "cancel": "取消",
    "myproject": "我的项目",
    "tutorials": "教程",
    "samples": "项目示例",
    "forum": "社区",
    "resetPassword": "重置密码" ,
    "resetSuccess": "密码修改成功",
    "captchaTipTitle": "收不到短信验证码，可能是以下原因导致：",
    "captchaTip1": "由于手机安全软件拦截，验证码短信被拦截进了垃圾箱，请打开垃圾箱查看",
    "captchaTip2": "由于运营商通道故障造短信发送时间延迟，请耐心等候或点击重新获取验证码",
    "captchaTip3": "核实您的手机是否是正常能够接受短信状态，停机、欠费或短信箱存储已满状态不能接收到短信",
    "help": "如不能顺利注册, 可以加 598016249 qq群, 联系管理员注册",
    "nicknameExists": "该昵称已经存在",
    "nicknameLong": "昵称长度不能超过 {{max}}",
    "nicknameShort": "昵称长度不能小于 {{min}}(中文), 4(英文)",
    "point": "积分",
    "mywidgets": "我的组件",
    "myorders": "我的订单",
    "switchLang": "English",
    inviteCode: "邀请码"
}


// WEBPACK FOOTER //
// ./src/i18n/locale.zh-cn.js